export const moqsDiscountSubMenu = [{
  path: '/moqs-discounts/list/:moqId(\\d+)',
  component: () => import('@/views/moqs-discounts/list.vue'),
  name: 'schemeManagement.moqsDiscount.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Regional Manager', 'Zonal Manager'],
    title: 'schemeManagement.moqsDiscount.title',
    noCache: true,
    icon: 'auction',
    hidden: true
  }
}, {
  path: '/moqs-discounts/edit/:id(\\d+)',
  component: () => import('@/views/moqs-discounts/manage.vue'),
  name: 'schemeManagement.moqsDiscount.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'schemeManagement.moqsDiscount.edit',
    noCache: true,
    activeMenu: '/moqs-discounts/list/:moqId(\\d+)',
    hidden: true
  }
}, {
  path: '/moqs-discounts/add/:moqId(\\d+)',
  component: () => import('@/views/moqs-discounts/manage.vue'),
  name: 'schemeManagement.moqsDiscount.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'schemeManagement.moqsDiscount.add',
    noCache: true,
    activeMenu: '/moqs-discounts/list/:moqId(\\d+)',
    hidden: true
  }
}];